import React from 'react';
import { Link } from 'react-router-dom';
import { SiteSection, SiteSectionHeader } from '../../../../components/site';
import type { ProductFeatureShowcaseConfig } from '../../../product-subpage/types';

export const PlatformFeatureShowcase: React.FC<{
  showcase: ProductFeatureShowcaseConfig;
}> = ({ showcase }) => (
  <SiteSection id="architecture" className="platform-feature-showcase">
    <SiteSectionHeader
      eyebrow={showcase.eyebrow ?? 'FEATURES'}
      title={showcase.title}
      subtitle={showcase.subtitle}
      align="center"
    />
    <div className="platform-feature-showcase__list">
      {showcase.items.map((item, index) => {
        const isReversed = index % 2 === 0;
        return (
          <section
            key={item.title}
            className={`platform-feature-module${isReversed ? ' platform-feature-module--reverse' : ''}`}
          >
            <div className="platform-feature-module__visual">
              <img
                src={item.image.src}
                alt={item.image.alt}
                width={item.image.width}
                height={item.image.height}
                loading="lazy"
              />
            </div>
            <article className="platform-feature-module__content">
              <h3 className="platform-feature-module__title">{item.title}</h3>
              <p className="platform-feature-module__desc">{item.description}</p>
              {item.cta && (
                <Link className="platform-feature-module__cta" to={item.cta.to}>
                  {item.cta.label}
                </Link>
              )}
            </article>
          </section>
        );
      })}
    </div>
  </SiteSection>
);
